export default "__VITE_ASSET__BXVTV_E___"